import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryButton } from 'common/components/index';
import { ReactComponent as CloseIcon } from 'applicaiton/assets/close.svg';
import { ReactComponent as SuccessIcon } from 'applicaiton/assets/success-icon.svg';
import { StyledModal } from './styles';
import { Modal } from '@mui/material';
import { SuccessModalProps } from './modules';

/**
 * A component that displays a modal dialog indicating that the user's password has been successfully changed.
 * @param onClose - A function to be called when the user closes the modal.
 */
const SuccessChangePasswordModal: FC<SuccessModalProps> = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal open={true}>
      <StyledModal>
        <CloseIcon onClick={onClose} />
        <div>
          <SuccessIcon />
          <p>{t('users.password_modal.title')}</p>
          <SecondaryButton onClick={onClose}>
            {t('users.password_modal.ok')}
          </SecondaryButton>
        </div>
      </StyledModal>
    </Modal>
  );
};

export default SuccessChangePasswordModal;
